import { useEffect, useState } from 'react';
import { Notification, useToaster } from 'rsuite';
import cancel from '../../../favicon/cancel.svg'
import invitation_sent from '../../../favicon/invitation_sent.gif'
import { APIRequest, ApiUrl } from '../../../Helpers/ApiHelper';
import colourStyles from "../../../Helpers/colourStyles";
import hasError from '../../../Helpers/ErrorHelper';
import CustomLoader from '../../comman/Loader/CustomLoader';
import Select from 'react-select';

const InvaiteModal = ({ ...props }) => {
    const { showModal, setShowModal, campaign_id ,influencer} = props;
    const [isLoading, setIsLoading] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const toaster = useToaster()
    const [selectedInfluencers, setSelectedInfluencers] = useState([]);
  
   

    const inviteInfleuncers = () => {

        let config = {
            url: `${ApiUrl.inviteInfluencers}`,
            method: 'POST',
            body: {
                influncers: selectedInfluencers.map((val) => val.value),
                campaign_id
            }
        }
        if (selectedInfluencers?.length > 0) {
            setIsLoading(true);
            APIRequest(
                config,
                res => {
                    setSelectedInfluencers([]);
                    setIsLoading(false);
                    setShowModal(false);
                },
                err => {
                    if (err.response.status === 422)
                        setValidationErrors(err?.response?.data.errors);
                    setIsLoading(false);

                }

            )
        } else {
            toaster.push(<Notification type='warning' header="Warning"  >Please select an influencer to invite </Notification>, {
                placement: 'topEnd'
            });
        }
    }

    const handleInvite = (e) => {
        e.preventDefault();
        inviteInfleuncers()

    }


    return (
        <>
            {showModal ? (
                <>
                    <CustomLoader visible={isLoading} />
                    <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

                        <div className="fixed inset-0 z-10 overflow-y-auto ">

                            <div className="flex min-h-full  justify-center p-4 text-center items-center sm:p-0">

                                <div className="relative transform  rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 ">
                                        <div className="close-modal" onClick={setShowModal}>
                                            <img alt="closemodal" src={cancel} />
                                        </div>
                                     
                                            
                                                <div className="sm:flex ">
                                                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                        <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Invite  influncers</h3>
                                                        <div className="mt-2">
                                                            <p className="text-sm text-gray-500">Invite the people of your choice on this platform .</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="sm:flex ">
                                                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                                                        <div className="mt-2">

                                                            <Select
                                                                placeholder="Invite Influencer"
                                                                closeMenuOnSelect={false}
                                                                className="mt-1 "
                                                                isMulti
                                                                menuPlacement={"auto"}
                                                                styles={colourStyles}
                                                                options={influencer?.map(item => ({ label: item?.name, value: item?.id }))}
                                                                defaultValue={selectedInfluencers}
                                                                onChange={(value) => setSelectedInfluencers(value)}

                                                            />
                                                        </div>
                                                        {hasError(validationErrors, 'influncers')}
                                                    </div>
                                                </div>
                                            
                                        

                                    </div>
                                    
                                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                            <button type="button" onClick={(e) => handleInvite(e)} className="mt-3 inline-flex w-full text-white justify-center rounded-lg border bg-greenBtn px-4 py-2 text-base font-medium shadow-sm hover:bg-greenBtn focus:outline-none  btn-anim i  sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"> Invite </button>
                                        </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : null}
        </>
    )

};



export default InvaiteModal;
